import { activityManagerMixin } from './ActivityManagerMixin';
import { zoomManagerMixin } from './ZoomManagerMixin';

export default { activityManagerMixin, zoomManagerMixin };
